import { useTranslation } from 'next-i18next'
import React from 'react'

import { TEST_LOCATORS } from '@src/constants/test-locators'
import { useStatsigDynamicConfig } from '@src/experiments/statsig-integration/use-statsig-dynamic-config.hook'

import styles from './productForm.module.scss'

export function ProductSubscriptionTermsNotice() {
  const { t } = useTranslation('common')
  const subscriptionTermsUrl = useStatsigDynamicConfig<string>('subscriptionsTermsUrl')

  return (
    <p className={styles.subscriptionTermsNotice} data-testid={TEST_LOCATORS.PRODUCT_FORM_SUBSCRIPTION_TERMS}>
      {t('pdp_subscription_terms_notice_prefix')}
      <a href={subscriptionTermsUrl} className={styles.subscriptionTermsNotice__link} target="_blank" rel="noopener">
        {t('pdp_subscription_terms_notice_link')}
      </a>
      {t('pdp_subscription_terms_notice_suffix')}
    </p>
  )
}
